import React from "react";
import { Box, Typography, InputBase } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FILTER_TABS } from "./constants";
import { ExportButton } from "../../../../../components/common/Buttons";

const SearchIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

const FilterTabs = ({ activeFilter, onFilterChange, search, onSearchChange, summary, onExport, exportDisabled }) => {
  const theme = useTheme();
  const t     = theme.custom;

  // Tab counts derived from summary
  const counts = {
  "billable":        summary?.billable             ?? "",
  "non-billable":    summary?.nonBillable          ?? "",
  new:               summary?.newPendingAllocation ?? "",
  available:         summary?.available            ?? "",
  partial:           summary?.partiallyAllocated   ?? "",
  "fully-allocated": summary?.fullyAllocated       ?? "",  // ← NEW
  all:               summary?.totalAssociates      ?? "",  // ← NEW
};

  return (
    <Box sx={{
      display: "flex", alignItems: "center",
      justifyContent: "space-between",
      padding: "0 20px",
      borderBottom: `1px solid ${t.border2}`,
      gap: "12px",
    }}>
      {/* Filter tab pills */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {FILTER_TABS.map((tab) => {
          const isActive = activeFilter === tab.id;
          const count    = counts[tab.id];
          return (
            <Box
              key={tab.id}
              onClick={() => onFilterChange(tab.id)}
              sx={{
                display: "flex", alignItems: "center", gap: "5px",
                padding: "10px 14px", cursor: "pointer",
                borderBottom: isActive
                  ? `2px solid ${t.accent}`
                  : "2px solid transparent",
                transition: "all 0.15s",
                "&:hover": { background: t.surface2 },
              }}
            >
              {/* New tab gets a flag icon */}
              {tab.id === "new" && (
                <Box component="span" sx={{ fontSize: "9px", color: t.accent }}>⚑</Box>
              )}
              <Typography sx={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "12.5px",
                fontWeight: isActive ? 600 : 400,
                color: isActive ? t.accent : t.text2,
                whiteSpace: "nowrap",
              }}>
                {tab.label}
                {count !== "" && (
                  <Box component="span" sx={{ color: t.text3, ml: "4px" }}>
                    ({count})
                  </Box>
                )}
              </Typography>
            </Box>
          );
        })}
      </Box>

      {/* Search & Export */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Box sx={{
          display: "flex", alignItems: "center", gap: "8px",
          background: t.surface2, border: `1px solid ${t.border2}`,
          borderRadius: "4px", padding: "6px 12px", width: "240px",
          flexShrink: 0,
        }}>
          <Box sx={{ color: t.text3 }}><SearchIcon /></Box>
          <InputBase
            placeholder="Search name, skill, level..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            sx={{
              flex: 1,
              fontFamily: "'Inter', sans-serif",
              fontSize: "12px", color: t.text,
            }}
          />
        </Box>

        <ExportButton
          label="Export"
          onClick={onExport}
          disabled={exportDisabled}
        />
      </Box>
    </Box>
  );
};

export default FilterTabs;